import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

// --------------------------------------------------------
// ENDPOINTS
// --------------------------------------------------------
const API_BASE = "/admin/request-status";

export async function getRequestStatusPending() {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.get(`${API_BASE}?type=pending`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

const RequestStatusPendingService = {
  getRequestStatusPending,
};

export default RequestStatusPendingService;
